import request from './request'

/**
 * 取得多個選項列舉
 * @param {Array} typeCodeList - 列舉型別代碼的陣列
 * @return {Promise} 解析伺服器回應的Promise
 */
function getMuiltOptionEnum(typeCodeList) {
  return request({
    url: '/optionEnum/getMuiltOptionEnum',
    method: 'post',
    data: typeCodeList,
  })
}

/**
 * 取得單一選項列舉
 * @param {String} typeCode - 要取得的選項列舉的型別代碼
 * @return {Promise} 解析伺服器回應的Promise
 */
function getOptionEnum(typeCode) {
  return request({
    url: '/optionEnum/getOptionEnum',
    method: 'get',
    params: { typeCode },
  })
}

export default {
  getMuiltOptionEnum,
  getOptionEnum,
}
